import {handleGqlResponseBody} from '@/utils/apollo.util';
import {getObjectFromLocalStorage, setObjectToLocalStorage} from '@/utils/local-storage.util';
import {GET_SYSTEM_CONFIG_QUERY} from '@/graphql/admin/system-config/system-config.query';

const systemConfig = {
	state: {
		systemConfigs: getObjectFromLocalStorage('systemConfigs')
	},
	getters: {
		getLogo(state) {
			if (!state.systemConfigs) return null;
			return state.systemConfigs.logo;
		},
		isSystemReady(state) {
			return !!state.systemConfigs;
		}
	},
	actions: {
		async loadSystemConfigs({state}) {
			try {
				const configs = await handleGqlResponseBody(({query}) => {
					return query({
						query: GET_SYSTEM_CONFIG_QUERY,
						fetchPolicy: 'no-cache'
					});
				});
				
				state.systemConfigs = configs;
				setObjectToLocalStorage('systemConfigs', configs);
			} catch (e) {
				// Catch
				console.log('Error loading system configs', e);
			}
		}
	}
};

export default systemConfig;
